export const MessageActionTypes = {
  messageUpdate: 'ui/message/update',
  messageReset: 'ui/message/reset',
}
